import { useLayoutEffect } from 'react';
import { useSiteSettings } from '../hooks/useContent';
import { applySiteFavicon } from '../utils/applySiteFavicon';
import { applySiteDocumentTitle } from '../utils/applySiteDocumentTitle';
import {
  cachePublicDocumentTitle,
  getCachedPublicDocumentTitle,
  DEFAULT_PUBLIC_DOCUMENT_TITLE
} from '../utils/siteTitleDefaults';

/** Applies site favicon and public browser tab title from site_settings. */
export default function SiteFavicon() {
  const { settings } = useSiteSettings();
  const publicTitle = settings?.site_public_title ?? '';

  useLayoutEffect(() => {
    applySiteFavicon(settings?.site_favicon_url);
  }, [settings?.site_favicon_url]);

  useLayoutEffect(() => {
    const resolved = String(publicTitle || '').trim() || DEFAULT_PUBLIC_DOCUMENT_TITLE;
    const previousCached = getCachedPublicDocumentTitle();
    cachePublicDocumentTitle(resolved);
    // Do not overwrite page-specific SEO titles (e.g. trek EventDetail via usePageSeo).
    const current = typeof document !== 'undefined' ? String(document.title || '').trim() : '';
    const stillSiteDefault =
      !current ||
      current === previousCached ||
      current === DEFAULT_PUBLIC_DOCUMENT_TITLE ||
      current === resolved;
    if (stillSiteDefault) {
      applySiteDocumentTitle(publicTitle, DEFAULT_PUBLIC_DOCUMENT_TITLE);
    }
  }, [publicTitle]);

  return null;
}
